<template>
<div class="card">
    <div class="card-header d-flex justify-content-between">
        <h2 class="card-title mb-0 text-nowrap"><font-awesome-icon icon="chart-bar" /> Ergebnis</h2>
        <div class="text-right">
            <button type="button" class="btn btn-light" @click="$emit('back')">
            <font-awesome-icon icon="arrow-left" fixed-width />
            <span>zur Gewichtung</span>
        </button></div>
    </div>
    <ul class="list-group">
        <li v-for="result in results" :key="result.party" class="list-group-item">
            <mat-result :result="result"
                        :answer="answer"
                        :weight="weight"
                        :party-answer="answers[result.party]"
                        :party-reason="reasons[result.party] || []"
            />
        </li>
    </ul>
</div>
</template>

<script>
import MatResult from './MatResult';

import parties from '../data/parties';
import answers from '../data/answers';
import reasons from '../data/reasons';

export default {
    name: "MatResults",
    components: {
        MatResult
    },
    props: {
        answer: Array,
        weight: Array
    },
    data() {
        return {
            parties,
            answers,
            reasons,
            show: {}
        }
    },
    computed: {
        results() {
            const result = [];
            Object.keys(this.parties).forEach(party => {
              const percent = this.computeMatch(party);

              result.push(
                  {
                    party,
                    percent,
                    position: percent + (party === 'Die PARTEI' ? 100 : 0)
                  }
              );
            });

            return result.sort((a, b) => b.position - a.position);
          }
    },
    methods: {
        computeMatch(party) {
            const count = this.answer.length;
            const partyAnswers = this.answers[party];

            let points = 0;
            let totalPoints = 0;

            for (let i = 0; i < count; i++) {
                if (this.answer[i] === null) {
                    continue;
                }

                const diff = Math.abs(partyAnswers[i] - this.answer[i]);
                const weight = this.weight && this.weight[i] ? 2 : 1;

                switch (diff) {
                    case 0:
                        points += 2 * weight;
                        break;

                    case 1:
                        points += 1 * weight;
                        break;

                    default:
                        points += 0;
                        break;
                }

                totalPoints += 2 * weight;
            }

            return Math.round(100 * points / totalPoints);
        }
    }
}
</script>

<style scoped>

</style>